module.exports = __webpack_public_path__ + "static/Minimum-b5a95fe007aefc9e89862a397b898eeb.jpg";